var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var ThemeDebug_exports = {};
__export(ThemeDebug_exports, {
  ThemeDebug: () => ThemeDebug
});
module.exports = __toCommonJS(ThemeDebug_exports);
var import_react = __toESM(require("react")), import_use_did_finish_ssr = require("@tamagui/use-did-finish-ssr"), import_use_force_update = require("@tamagui/use-force-update"), import_react_dom = require("react-dom"), import_jsx_runtime = require("react/jsx-runtime");
let node;
function ThemeDebug({
  themeState,
  themeProps,
  children
}) {
  if (process.env.NODE_ENV === "development") {
    const isHydrated = (0, import_use_did_finish_ssr.useDidFinishSSR)(), [onChangeCount, setOnChangeCount] = import_react.default.useState(0), rerender = (0, import_use_force_update.useForceUpdate)(), id = import_react.default.useId();
    return process.env.NODE_ENV === "development" && typeof document < "u" && (node || (node = document.createElement("div"), node.style.height = "200px", node.style.overflowY = "scroll", node.style.position = "fixed", node.style.zIndex = 1e7, node.style.bottom = "30px", node.style.left = "30px", node.style.right = "30px", node.style.display = "flex", node.style.border = "1px solid #888", node.style.flexDirection = "row", node.style.background = "var(--background)", document.body.appendChild(node))), import_react.default.useEffect(() => {
      themeState.themeManager?.parentManager?.onChangeTheme((name, manager) => {
        setOnChangeCount((p) => ++p), console.warn(
          `theme changed for ${themeState.themeManager?.id} from parent ${themeState.themeManager?.parentManager?.id} to new name`,
          name
        );
      });
    }, [themeState.themeManager]), import_react.default.useEffect(() => {
      const tm = setInterval(rerender, 1e3);
      return () => clearTimeout(tm);
    }, []), themeProps["disable-child-theme"] || !isHydrated ? children : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, { children: [
      (0, import_react_dom.createPortal)(
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
          "code",
          {
            style: {
              whiteSpace: "pre",
              maxWidth: 250,
              overflow: "auto",
              padding: 5
            },
            children: [
              "<Theme ",
              id,
              " />\xA0",
              JSON.stringify(
                {
                  propsName: themeProps.name,
                  name: themeState?.state?.name,
                  className: themeState?.state?.className,
                  inverse: themeProps.inverse,
                  forceClassName: themeProps.forceClassName,
                  parent: themeState.themeManager?.state.parentName,
                  id: themeState.themeManager?.id,
                  parentId: themeState.themeManager?.parentManager?.id,
                  isNew: themeState.isNewTheme,
                  onChangeCount,
                  listening: [...themeState.themeManager?._listeningIds || []].join(
                    ","
                  ),
                  _numChangeEventsSent: themeState.themeManager?._numChangeEventsSent
                },
                null,
                2
              )
            ]
          }
        ),
        node
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { style: { color: "red" }, children: id }),
      children
    ] });
  }
  return children;
}
ThemeDebug.displayName = "ThemeDebug";
//# sourceMappingURL=ThemeDebug.js.map
